<template>
<div class="chapter">
<div class="inner_page">
<h1>The Story</h1>
<h1 class="sigil_not_in_toc">of Treasure Seekers </h1>
<h2 class="calibre3 sigil_not_in_toc" id="calibre_pb_0">E. Nesbit</h2>
<blockquote class="calibre7"><div class="calibre8">
</div>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?5d34f64e